import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

import { getInitials } from 'webapp/utils/common';

export interface Args {
	name?: string;
	avatar?: string;
	color?: string;
}

export default class AvatarOrInitialsComponent extends Component<Args> {
	get color() {
		return this.args.color || '#4D71F1';
	}

	get isInitials() {
		return !this.args.avatar || this.args.avatar.includes('gravatar');
	}

	get initials() {
		return getInitials(this.args.name || '');
	}

	get style() {
		if (!this.isInitials) {
			return;
		}

		return htmlSafe(`background-color:${this.color}`);
	}

	<template>
		<div class="avatar {{if this.isInitials 'initials'}}" style={{this.style}}>
			{{#if this.isInitials}}
				{{this.initials}}
			{{else}}
				<img src={{@avatar}} alt="" />
			{{/if}}
		</div>
	</template>
}
